import { MdInsertDriveFile, MdMic, MdPhotoCamera, MdVideocam } from "react-icons/md";
import type { MediaKind } from "../ui";

/**
 * The little glyph WhatsApp puts before "Photo" / "Voice message" in a chat
 * list, and on an attachment row that has no playable copy. A real icon, not
 * an emoji: emoji render as somebody else's artwork at somebody else's weight,
 * which is exactly what made the console look unlike the app.
 */
export default function MediaIcon({ kind }: { kind: MediaKind }) {
  switch (kind) {
    case "image":
      return <MdPhotoCamera />;
    case "video":
      return <MdVideocam />;
    case "audio":
      return <MdMic />;
    default:
      return <MdInsertDriveFile />;
  }
}

/** The composer's own glyphs that ShellIcon lacks, as prototype v2.20 draws them (chat.js ICONS.chat*, core.js smile). */
const GLYPHS = {
  smile: '<circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/>',
  speak: '<path d="M2 10v3"/><path d="M6 6v11"/><path d="M10 3v18"/><path d="M14 8v7"/><path d="M18 5v13"/><path d="M22 10v3"/>',
  stop: '<rect x="6" y="6" width="12" height="12" rx="2.5" fill="currentColor" stroke="none"/>',
  redo: '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>',
  photos: '<path d="M18 22H4a2 2 0 0 1-2-2V6"/><path d="m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18"/><circle cx="12" cy="8" r="2"/><rect width="16" height="16" x="6" y="2" rx="2"/>',
} as const;

/** Kept, as ShellIcon's: a new { __html } each render rewrote the composer's buttons' paths as you typed, and a press
 *  that began on a path rewritten before the release was no click. */
const HTML = Object.fromEntries(Object.entries(GLYPHS).map(([k, v]) => [k, { __html: v }])) as Record<keyof typeof GLYPHS, { __html: string }>;

export function Glyph({ name, size }: { name: keyof typeof GLYPHS; size?: number }) {
  return (
    <svg
      className="lzi"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      style={size ? { width: size, height: size } : undefined}
      dangerouslySetInnerHTML={HTML[name]}
    />
  );
}
